@if (!!haytoolassist) {
    <iframe
        [src]="haytoolassist"
        width="100%"
        height="100%"
        title="HAYTOOL ASSIST"
    ></iframe>
} @else {
    <app-progress-spinner></app-progress-spinner>
}
